export default __webpack_public_path__ + "static/media/ag.c5de3d88.svg";